import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M57.57 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51s-51 22.834-51 51c0 28.167 22.833 51 51 51"
    />
    <path fill="#D8FFFF" d="M39.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m20.19 20.9 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM33.5 105a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#D8FFFF"
      d="M111 57.5h-5.5V52c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.5H97c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.5V66c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.5h5.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#00D8D8"
      d="M84 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M81.93 45.51V27.69c0-.69-.56-1.26-1.26-1.26h-6.19c-.69 0-1.26.56-1.26 1.26v10.88L59.81 27.88a2.9 2.9 0 0 0-3.63 0L34.07 45.51v39.71c0 2.4 1.95 4.35 4.35 4.35h39.17c2.4 0 4.35-1.95 4.35-4.35V45.51z"
    />
    <path
      fill="#0597A3"
      d="M90.63 53.4c-.62 0-1.24-.19-1.77-.58L58.8 30.77a1.35 1.35 0 0 0-1.6 0L27.14 52.82a3 3 0 0 1-4.19-.64 3 3 0 0 1 .64-4.19l30.06-22.05c2.59-1.9 6.08-1.9 8.69 0L92.41 48c1.34.98 1.62 2.86.64 4.19-.59.8-1.5 1.23-2.42 1.23zM86.45 86.57H85.2c.03-.14.04-.28.04-.42V78.4h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25h-19c-.07 0-.14.01-.22.02-.07 0-.14-.02-.22-.02h-19c-.23 0-.44.04-.65.11a2.3 2.3 0 0 0-.65-.11h-19c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25H31v7.75c0 .14.02.28.04.42h-1.73c-1.66 0-3 1.34-3 3s1.34 3 3 3h57.13c1.66 0 3-1.34 3-3s-1.34-3-3-3zM75.24 78.4h5.5v7.75c0 .14.02.28.04.42H75.2c.03-.14.04-.28.04-.42zm-9.43 0h2.25c.07 0 .14-.01.22-.02.07 0 .14.02.22.02h2.25v7.75c0 .14.02.28.04.42h-5.02c.03-.14.04-.28.04-.42zm-10 0h5.5v7.75c0 .14.02.28.04.42h-5.58c.03-.14.04-.28.04-.42zm-10.3 0h2.25c.23 0 .44-.04.65-.11.21.06.42.11.65.11h2.25v7.75c0 .14.02.28.04.42h-5.89c.03-.14.04-.28.04-.42V78.4zm-10 7.75V78.4h5.5v7.75c0 .14.02.28.04.42h-5.58c.03-.14.04-.28.04-.42"
    />
  </svg>
);
const SvgEnrichedIconDeckBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDeckBrand);
export default Memo;
